import 'classlist-polyfill';

const ATTRIBUTE_STEP = 'data-carousel-step';
const ATTRIBUTE_ACTIVE = 'data-carousel-active';
const CONTENT_ATTRIBUTE = 'data-carousel-content';
const COLOR_ATTRIBUTE = 'data-color';

export default class HeroCarousel {
    constructor(props) {
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
        this.captureStepClick = this.captureStepClick.bind(this);

        this.element = props.element;
        this.stepElement = props.stepElement;
        this.hoverPauseElements = props.hoverPauseElements;
        this.intervalTime = props.intervalTime;
        this.delayTime = props.delayTime;
        this.index = 1;
        this.interval = null;
        this.timeout = null;
        this._count = null;
        this.listenForStepClicks();
        this.listenForHoverStates();
        this.colorElements = document.querySelectorAll('[data-use-carousel-color]');
        this.backgroundColorElements = document.querySelectorAll('[data-use-carousel-background-color]');
        this.syncStepsElements = document.querySelectorAll('[data-use-hero-carousel-step]');

        this.performanceTracked = {};
        this.trackPerformance('hero_carousel_initialized');
    }

    start(customDelay) {
        const delay = customDelay || this.delayTime;

        this.goToStep(this.index);

        this.trackPerformance('hero_carousel_start');

        this.timeout = setTimeout(() => {
            this.trackPerformance('hero_carousel_set_interval');

            this.interval = setInterval(() => {
                if (document.readyState === 'complete') {
                    this.next();
                }
            }, this.intervalTime);
        }, delay);
    }

    stop() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
        this.stopListeningForHoverStates();
    }

    pause() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
    }

    resume() {
        this.start(0);
    }

    next() {
        this.trackPerformance('hero_carousel_next');
        this.goToStep(this.index + 1);
    }

    count() {
        if (!this._count) {
            this._count = this.stepElement.querySelectorAll(`[${ATTRIBUTE_STEP}]`).length;
        }
        return this._count;
    }

    trackPerformance(key) {
        if (window.performance && window.performance.mark && !this.performanceTracked[key]) {
            window.performance.mark(key);
            this.performanceTracked[key] = true;
        }
    }

    goToStep(stepIndex) {
        for (let step of this.stepElement.querySelectorAll(`[${ATTRIBUTE_ACTIVE}]`)) {
            step.removeAttribute(ATTRIBUTE_ACTIVE);
        }
        for (let step of this.element.querySelectorAll(`[${CONTENT_ATTRIBUTE}]`)) {
            step.removeAttribute(ATTRIBUTE_ACTIVE);
        }

        this.index = (Math.abs(stepIndex) % this.count()) || this.count();
        this.element.setAttribute(ATTRIBUTE_STEP, this.index);

        if (this.currentStepElement()) {
            this.currentStepElement().setAttribute(ATTRIBUTE_ACTIVE, true);
        }

        if (this.currentContentElement()) {
            this.currentContentElement().setAttribute(ATTRIBUTE_ACTIVE, true);

            const color = this.currentContentElement().getAttribute(COLOR_ATTRIBUTE);
            this.element.style.color = color;

            for (let el of this.colorElements) {
                el.style.color = color;
            }

            for (let el of this.backgroundColorElements) {
                el.style.backgroundColor = color;
            }

            for (let el of this.syncStepsElements) {
                el.setAttribute('data-hero-carousel-current-step', this.index);
            }
        }
    }

    currentStepElement() {
        return this.stepElement.querySelector(`[${ATTRIBUTE_STEP}="${this.index}"]`);
    }

    currentContentElement() {
        return this.element.querySelector(`[${CONTENT_ATTRIBUTE}][${ATTRIBUTE_STEP}="${this.index}"]`);
    }

    listenForStepClicks() {
        for (let step of this.stepElement.querySelectorAll(`[${ATTRIBUTE_STEP}]`)) {
            step.addEventListener('click', this.captureStepClick);
        }
    }

    listenForHoverStates() {
        for (let element of this.hoverPauseElements) {
            element.addEventListener('mouseenter', this.pause);
            element.addEventListener('mouseleave', this.resume);
        }
    }

    stopListeningForHoverStates() {
        for (let element of this.hoverPauseElements) {
            element.removeEventListener('mouseenter', this.pause);
            element.removeEventListener('mouseleave', this.resume);
        }
    }

    captureStepClick(event) {
        let stepElement = event.target;
        let stepElementIndex = parseInt(stepElement.getAttribute(ATTRIBUTE_STEP));

        if (stepElementIndex) {
            this.stop();
            this.goToStep(stepElementIndex);
        }
    }

    static create({
        elementSelector='[data-carousel]',
        stepElementSelector='[data-carousel-steps]',
        intervalTime=5000,
        delayTime=0,
        hoverPauseElements=[]
    } = {}) {
        const element = document.querySelector(elementSelector);
        const stepElement = document.querySelector(stepElementSelector);

        const carousel = new HeroCarousel({
            element: element,
            stepElement: stepElement,
            intervalTime: intervalTime,
            delayTime: delayTime,
            hoverPauseElements: hoverPauseElements,
        });

        return carousel;
    }
};



// WEBPACK FOOTER //
// ./js/marketing/components/hero-carousel.js